/**
 * **Solo `/muchas-gracias`:** dos URLs en Railway, una por tier.
 *
 * - Basic → `VITE_MUCHAS_GRACIAS_CTA_URL_BASIC`
 * - VIP   → `VITE_MUCHAS_GRACIAS_CTA_URL_VIP`
 *
 * Si el bundle no tiene la variable (caso raro), fallback: `telegram_url` de `/api/validate-subscription`
 * (mismas keys en el servidor).
 *
 * Texto del botón (opcional): `VITE_MUCHAS_GRACIAS_CTA_LABEL_BASIC` / `VITE_MUCHAS_GRACIAS_CTA_LABEL_VIP`.
 */

import { normalizeTelegramPlanTier } from "@/lib/telegramPlanTier";

function trimUrl(raw: string | undefined): string {
  return typeof raw === "string" ? raw.trim() : "";
}

/** URL del CTA en `/muchas-gracias` para plan Basic. */
export function getMuchasGraciasCtaUrlBasic(): string {
  return trimUrl(import.meta.env.VITE_MUCHAS_GRACIAS_CTA_URL_BASIC);
}

/** URL del CTA en `/muchas-gracias` para plan VIP. */
export function getMuchasGraciasCtaUrlVip(): string {
  return trimUrl(import.meta.env.VITE_MUCHAS_GRACIAS_CTA_URL_VIP);
}

/** Texto del botón CTA si definís labels en Railway; si no, devuelve cadena vacía y la página usa el default. */
export function getMuchasGraciasCtaLabel(tier: "basic" | "vip"): string {
  const raw =
    tier === "vip"
      ? import.meta.env.VITE_MUCHAS_GRACIAS_CTA_LABEL_VIP
      : import.meta.env.VITE_MUCHAS_GRACIAS_CTA_LABEL_BASIC;
  return trimUrl(raw);
}

export function normalizePlanTierForMuchasGracias(
  planTier: string | undefined,
): "basic" | "vip" {
  return normalizeTelegramPlanTier(planTier);
}

/**
 * URL final del CTA en Muchas Gracias.
 * 1) `VITE_MUCHAS_GRACIAS_CTA_URL_*` en el bundle; 2) si falta, `telegram_url` de la API.
 */
export function resolveFinalTelegramInviteUrl(
  planTier: string | undefined,
  apiTelegramUrl: string | undefined,
): string {
  const tier = normalizeTelegramPlanTier(planTier);
  const fromEnv =
    tier === "vip" ? getMuchasGraciasCtaUrlVip() : getMuchasGraciasCtaUrlBasic();
  if (fromEnv) return fromEnv;
  return trimUrl(apiTelegramUrl);
}
